import React from "react";
export function XBEconfWeb2({
  language='en',
  handleFilter,
  checkIfShow,
}) {
  // return <div className="l_block l_block--hide-34 noselect">


  //                   <div onClick={() => { handleFilter('all'); }} className={`x_cat_item x_cat_item_or x_cat_item--all ${checkIfShow('all') ? 'x_cat_item--active' : ''}`}>
  //                     <div className="x_sol_cardsul x_sol_cardsul--active">
  //                       <div className="x_cat_type_h">All stages</div>
  //                     </div>
  //                   </div>


  // </div>;

  return (
<div className="x_catnew0">
  <div id="w-node-84e35aabe73e-0eeff969" className="x_catnew_col">
    <div className="x_cat_decal0">
      <div className="x_cat_decal_inner">
        <div className="x_cat_decal_h x_cat_decal_h--dark">
          {language === 'en' ? 'Stage' : 'Готовность игры'}
        </div>
        <div className="x_cat_decal x_cat_decal--dark" />
      </div>
    </div>

    <div className="l_line_li">

      <div className="x_cat_sel0 x_cat_sel0--v">

      <div
        className={`x_catnew_item  ${checkIfShow('all') ? 'active' : ''}`}
        onClick={() => { handleFilter('all'); }}>
            {language === 'en' ? 'All stages' : 'Не важно'}
        </div>


        <div
          className={`x_catnew_item  ${checkIfShow('pre_launch') ? 'active' : ''}`}
          onClick={() => { handleFilter('pre_launch'); }}>
          <div className="l_line_li">
            {language === 'en' ? 'Pre-launch' : 'До запуска'}
          </div>
          <div className="x_catnew_next" />
        </div>

        <div
          className={`x_catnew_item  ${checkIfShow('early_access') ? 'active' : ''}`}
          onClick={() => { handleFilter('early_access'); }}>
          <div className="l_line_li">
            {language === 'en' ? 'Early access' : 'Ранний доступ'}
          </div>
          <div className="x_catnew_next" />
        </div>

        <div
          className={`x_catnew_item  ${checkIfShow('live_game') ? 'active' : ''}`}
          onClick={() => { handleFilter('live_game'); }}>
          <div className="l_line_li">
            {language === 'en' ? 'Live game' : 'Игра уже в доступе'}
          </div>
        </div>

      </div>
    </div>
  </div>
  <div className="x_catnew_col">
    <div className="x_cat_decal0">
      <div className="x_cat_decal_inner">
        <div className="x_cat_decal_h x_cat_decal_h--dark">
          {language === 'en' ? 'Monetization' : 'Тип монетизации'}
        </div>
        <div className="x_cat_decal x_cat_decal--dark" />
      </div>
    </div>
    <div className="l_line_li">
      <div className="x_cat_sel0 x_cat_sel0--v">


      <div
        className={`x_catnew_item  ${checkIfShow('premium') ? 'active' : ''}`}
        onClick={() => { handleFilter('premium'); }}>

          <div className="x_cat_itemnew_check">
            <div className="x_cat_item_check w-embed">
              <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
              </svg>
            </div>
          </div>
          <div className="l_line_li">
            <div>
              {language === 'en' ? 'Premium' : 'Премиум'}
            </div>
          </div>
        </div>

        <div
          className={`x_catnew_item  ${checkIfShow('microtransactions') ? 'active' : ''}`}
          onClick={() => { handleFilter('microtransactions'); }}>

          <div className="x_cat_itemnew_check">
            <div className="x_cat_item_check w-embed">
              <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
              </svg>
            </div>
          </div>
          <div className="l_line_li">
              {language === 'en' ? 'Microtransactions' : 'Микротранзакции'}
          </div>
        </div>

        <div
          className={`x_catnew_item  ${checkIfShow('subscriptions') ? 'active' : ''}`}
          onClick={() => { handleFilter('subscriptions'); }}>

          <div className="x_cat_itemnew_check">
            <div className="x_cat_item_check w-embed">
              <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
              </svg>
            </div>
          </div>
          <div className="l_line_li">
            {language === 'en' ? 'Subscriptions' : 'Подписки'}
          </div>
        </div>


      </div>
    </div>
  </div>
  <div className="x_catnew_col">
    <div className="x_cat_decal0">
      <div className="x_cat_decal_inner">
        <div className="x_cat_decal_h x_cat_decal_h--dark">
          {language === 'en' ? 'Platform' : 'Платформы'}
        </div>
        <div className="x_cat_decal x_cat_decal--dark" />
      </div>
    </div>
    <div className="l_line_li">
      <div className="x_cat_sel0 x_cat_sel0--v">


      <div
          className={`x_catnew_item  ${checkIfShow('pc_mac') ? 'active' : ''}`}
          onClick={() => { handleFilter('pc_mac'); }}>
          <div className="x_cat_itemnew_check">
            <div className="x_cat_item_check w-embed">
              <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
              </svg>
            </div>
          </div>
          <div className="l_line_li l_line--xs">
            <div>
              <div>PC/Mac</div>
            </div>
          </div>
        </div>

        <div
          className={`x_catnew_item  ${checkIfShow('web') ? 'active' : ''}`}
          onClick={() => { handleFilter('web'); }}>
          <div className="x_cat_itemnew_check">
            <div className="x_cat_item_check w-embed">
              <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
              </svg>
            </div>
          </div>
          <div className="l_line_li l_line--xs">
              Web
          </div>
        </div>

        <div
          className={`x_catnew_item  ${checkIfShow('mobile') ? 'active' : ''}`}
          onClick={() => { handleFilter('mobile'); }}>
          <div className="x_cat_itemnew_check">
            <div className="x_cat_item_check w-embed">
              <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
              </svg>
            </div>
          </div>
          <div className="l_line_li l_line--xs">
            {language === 'en' ? 'Mobile' : 'Мобильная игры'}
          </div>
        </div>

        <div
          className={`x_catnew_item  ${checkIfShow('console') ? 'active' : ''}`}
          onClick={() => { handleFilter('console'); }}>
          <div className="x_cat_itemnew_check">
            <div className="x_cat_item_check w-embed">
              <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
              </svg>
            </div>
          </div>
          <div className="l_line_li l_line--xs">
            {language === 'en' ? 'Console' : 'Консольная игра'}
          </div>
        </div>


      </div>
    </div>
  </div>
</div>


  )
}
